import { debug } from './debugging';

/**
 * Returns value of specified search param from request url or window.location.href
 *
 * @param queryParam - parameter name to look out for
 * @param serverRequest
 * @returns
 */
export function getSearchParamValue(queryParam: string): string {
  let searchParams: URLSearchParams;

  if (typeof window !== 'undefined') {
    try {
      searchParams = new URL(window.location.href).searchParams;
    } catch (error) {
      if (error instanceof Error) {
        debug(`getSearchParam(): ${error} (url=${window.location.href})`);
      }
      return '';
    }
  } else {
    return '';
  }

  return searchParams.get(queryParam) || '';
}
